<div mat-dialog-title>
  <div class="d-flex justify-content-between">
    <p>{{currentActionpage}}</p>
    <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>

<div mat-dialog-content>
  <div class="row eip-form-controls m-0 eip-mt-15">
    <div [hidden]="show"  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12" width="100%">
      <dynamic-form #dynamicFormComponent [repeatCount]=1> </dynamic-form>
    </div>
    <div *ngIf="show == true" class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
      <mat-form-field>
        <mat-label>Selected Discipline</mat-label>
        <input matInput [(ngModel)]="setDiscipline" [disabled]="show" />
      </mat-form-field>
    </div>
  </div>
  <div class="row eip-form-controls m-0 eip-mt-15">
    <div [hidden]="show" class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="view-info eip-mb-0">
        <mat-form-field>
          <mat-select placeholder="Select Element" (ngModelChange)="getItem($event)" [(ngModel)]="elementId" matInput
            required>
            <mat-option *ngFor="let data of elementList" [value]="data.tE_Id ">
              {{ data.tE_Description }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div *ngIf="show == true" class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
      <mat-form-field>
        <mat-label>Selected Element Description </mat-label>
        <input matInput [(ngModel)]="element" [disabled]="show" />
      </mat-form-field>
    </div>
    <div *ngIf="showItem" class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="view-info eip-mb-0">
        <mat-form-field>
          <mat-select placeholder="Select Item" [(ngModel)]="itemId" matInput required>
            <mat-option *ngFor="let data of itemList" [value]="data.tI_Id ">
              {{ data.tI_Description }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div *ngIf="showLabel" class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
      <mat-form-field>
        <mat-label>Selected Item Description</mat-label>
        <input matInput [(ngModel)]="item" [disabled]="show" />
      </mat-form-field>
    </div>
  </div>
  <div class="row eip-form-controls m-0 eip-mt-15">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 eip-mt-10">
      <div class="view-info eip-mb-0">
        <mat-label>Active Status:</mat-label>
        <div style="margin-top: 2%;">
          <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [(ngModel)]="activeStatus" [disabled]="false"
            [checked]="true"></kendo-switch>
        </div>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <div class="row justify-content-end flex-grow-1">
    <button class="btn btn-primary" (click)="Save()">Save</button>
  </div>
</div>